import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { MaterialDemandPosition } from 'src/app/_model/material-demand-position';

@Injectable()
export abstract class MaterialDemandPositionsDaoService implements Resetable {
  public abstract saveMaterialDemandPositions(
    materialDemandPositions: MaterialDemandPosition[],
  ): Promise<void>;
  public abstract getMaterialDemandPositions(): Promise<
    MaterialDemandPosition[]
  >;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
